module.exports = {
  google: {
    API_KEY: process.env.REACT_APP_GOOGLE_MAP_KEY || "",
    CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || "",
    SECRET: process.env.REACT_APP_GOOGLE_SECRET || "",
  },
  facebook: {
    APP_ID: process.env.REACT_APP_FACEBOOK_APP_ID || "",
  },
  api: {
    API_URL: process.env.REACT_APP_API_URL || "https://toon-stacker.tdtrg.com/apis/api",
    IMAGE_URL: process.env.REACT_APP_FILE_URL || "https://toon-stacker.tdtrg.com/apis/public/storage/uploads/",
    FLAGS: "../../assets/images/flags/",
  },
};
